import { Box, Link, Text } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsProviderEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface ProviderInformationProps {
  provider: BankingValueObjectsProviderEnum
}

const ProviderInformation = ({ provider: providerParam }: ProviderInformationProps) => {
  let provider,
    address,
    phone,
    url = null

  switch (providerParam) {
    case 'stripe':
      provider = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.stripe.name'
      )
      address = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.stripe.address'
      )
      phone = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.stripe.phone'
      )
      url = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.stripe.url'
      )
      break
    case 'fake':
      provider = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.fake.name'
      )
      address = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.fake.address'
      )
      phone = i18n.t(
        'expenses_v2.transactions.detail.proof_of_transfer_provider.providers.fake.phone'
      )
      break
  }

  if (!provider || !address || !phone || !url) {
    return null
  }

  const description = i18n.t('expenses_v2.transactions.detail.proof_of_transfer_provider.base', {
    provider,
    address,
    phone,
  })

  return (
    <Box width="full" justifyContent="flexStart" alignItems="flexStart" gap="s16">
      <Text.Header2 color="grey1000">
        {i18n.t('expenses_v2.transactions.detail.sections.additional_information')}
      </Text.Header2>
      <Text weight="normal" size="300" color="grey800">
        {description}
      </Text>
      <Link.Href href={url} target="_blank">
        {i18n.t('expenses_v2.transactions.detail.actions.more_details')}
      </Link.Href>
    </Box>
  )
}

export default ProviderInformation
